// Fields set by the backend only. They must never be sent back in a hotel update.
const READ_ONLY_HOTEL_FIELDS = ["subscriptionExpiresOn"];

export function mapHotel(hotel) {
    if (!hotel || typeof hotel !== 'object') {
        return hotel;
    }
    return {
        ...hotel,
        subscriptionExpiresOn: hotel.subscriptionExpiresOn ?? ""
    };
}

export function mapHotels(hotels) {
    return Array.isArray(hotels) ? hotels.map(mapHotel) : hotels;
}

export function toHotelUpdatePayload(hotel) {
    if (!hotel || typeof hotel !== 'object') {
        return hotel;
    }
    const payload = { ...hotel };
    READ_ONLY_HOTEL_FIELDS.forEach(field => delete payload[field]);
    return payload;
}
